const dreamvu = {
    title: "Computer Vision Intern",
    company: "DreamVu Inc.",
  };
  
  export default dreamvu;